import { useEffect, useState } from 'react';
import FormSpinner from './formComponents/FormSpinner';

export default function TeacherDetailsGradeTable({ loading, data }) {
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (loading === false && data !== null && data !== undefined) {
      const filteredGradeCounts = data.grade_counts.filter((gradeCount) => {
        // Check if any grade count value other than '0' exists
        return Object.keys(gradeCount).some(
          (key) => key !== 'title' && gradeCount[key] !== 0,
        );
      });

      // Update the filteredData state with the filtered grade counts
      setFilteredData({ ...data, grade_counts: filteredGradeCounts });
    }
  }, [loading]);

  const calculatePercentage = (gradeCount, total) => {
    return Math.round((gradeCount / total) * 100);
  };

  return (
    <div className='flex h-full w-full flex-col overflow-hidden rounded-lg border-2 border-x-slate-100 border-t-slate-50 border-b-slate-100 bg-white pt-5 pb-8 shadow-md'>
      {loading ? (
        <div>
          <FormSpinner loading={loading} />
        </div>
      ) : (
        <table className='w-full table-auto border-collapse bg-gradient-to-r from-slate-100 text-xs'>
          <thead>
            <tr className='text-xl font-bold text-brandText'>
              <th className='p-4 pl-14 pt-1 pb-1 text-left'>Course</th>
              {data?.possible_grades?.map((item, itemIdx) => (
                <th key={itemIdx} className='p-4 pt-1 pb-1 text-left'>
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='bg-white text-brandText'>
            {filteredData?.grade_counts?.map((item, itemIdx) => {
              const total = Object.values(item).reduce(
                (acc, val) => (typeof val === 'number' ? acc + val : acc),
                0,
              );
              return (
                <tr key={itemIdx} className='border-b-2 border-b-gray-100'>
                  <td className='p-4 pl-14 pt-2 pb-0.5 font-medium'>
                    {item.title}
                  </td>
                  {Object.entries(item)
                    .filter(([key]) => key !== 'title')
                    .map(([key, value]) => (
                      <td key={key} className='p-4 pt-2 pb-0.5 font-medium'>
                        {isNaN(total) ? 0 : calculatePercentage(value, total)}%{' '}
                        ({value})
                      </td>
                    ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      {filteredData?.grade_counts?.length < 1 && (
        <div className='flex h-full items-center justify-center px-8 text-xl font-normal text-gray-400'>
          No current grade data found
        </div>
      )}
    </div>
  );
}
